import { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { fetchData } from "store/actions/dataAction";
import { updateProfile } from "store/actions/profileAction";

import ModalChangePass from "./ModalChangePass";

import Button from "elements/Button";
import PhoneInput from "react-phone-input-2";
import Breadcrumb from "elements/breadcrumb";
import LoadingButton from "elements/Button/loadingButton";
import { handleConfirmSwal } from "utils/sweetAlert";

import "react-phone-input-2/lib/style.css";
import "assets/css/profile.css";

import Placeholder from "assets/images/profile-placeholder.png";

const ProfileForm = ({ fetchData, data, listProvince, breadcrumb }) => {
  const dispatch = useDispatch();

  const [profile, setProfile] = useState({
    name: "",
    province: "",
    city: "",
    address: "",
    phone: "",
    image: "",
  });
  const [image, setImage] = useState(Placeholder);

  const { user, isLoading } = useSelector((state) => state.profileReducer);

  useEffect(() => {
    if (user) {
      setProfile({
        name: user.name,
        province: user.province,
        city: user.city,
        address: user.address,
        phone: user.phone,
      });
      if (user.image) {
        setImage(user.image);
      } else {
        setImage(Placeholder);
      }
    }
  }, [user]);

  useEffect(() => {
    if (profile.province && !data[`city/${profile.province}`]) {
      fetchData(
        `http://www.emsifa.com/api-wilayah-indonesia/api/regencies/${profile.province}.json`,
        `city/${profile.province}`
      );
    }
  }, [fetchData, profile, data]);

  const onChange = (e) => {
    const { name, value } = e.target;
    setProfile({ ...profile, [name]: value });

    if (e.target.files) {
      let reader = new FileReader();
      reader.onload = (e) => {
        setImage(e.target.result);
      };
      if (e.target.files[0]) {
        reader.readAsDataURL(e.target.files[0]);
        setProfile({ ...profile, image: e.target.files[0] });
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    handleConfirmSwal(
      "Are you sure?",
      "Your profile will be updated",
      "warning",
      true,
      "Yes, update it!"
    ).then((result) => {
      if (result.isConfirmed) {
        dispatch(updateProfile("/profile", profile));
      }
    });
  };

  return (
    <section className="section-profile">
      <div className="container">
        <Breadcrumb data={breadcrumb} />

        {/* FORM UPDATE PROFILE */}
        <div className="col-6 mx-auto mt-5">
          <form onSubmit={handleSubmit}>
            {/* PHOTO */}
            <div className="mb-4">
              <label htmlFor="image" className="form-label d-flex flex-column ">
                <img
                  id="showImage"
                  src={image}
                  alt=""
                  className="profile-image mx-auto edited"
                />
              </label>

              <input
                type="file"
                className="form-control"
                aria-describedby="image"
                id="image"
                onChange={onChange}
                hidden
              />
            </div>

            {/* NAME */}
            <div className="mb-3">
              <label htmlFor="name" className="form-label">
                Name <label className="color-red">*</label>
              </label>
              <input
                type="text"
                className="form-control"
                aria-describedby="name"
                required
                id="name"
                name="name"
                value={profile.name}
                onChange={onChange}
              />
            </div>

            {/* PROVINCE SELECT */}
            <div className="mb-3">
              <label htmlFor="province" className="form-label">
                Province <label className="color-red">*</label>
              </label>
              <select
                className="form-select"
                aria-label="Default select example"
                required
                id="province"
                name="province"
                value={profile.province == null ? "" : profile.province}
                onChange={onChange}
              >
                <option hidden value="">
                  Open this select menu
                </option>
                {listProvince &&
                  listProvince.map((province, index) => (
                    <option key={index} value={province.id}>
                      {province.name}
                    </option>
                  ))}
              </select>
            </div>

            {/* CITY SELECT */}
            <div className="mb-3">
              <label htmlFor="city" className="form-label">
                City <label className="color-red">*</label>
              </label>
              <select
                className="form-select"
                aria-label="Default select example"
                required
                id="city"
                name="city"
                value={profile.city == null ? "" : profile.city}
                onChange={onChange}
              >
                <option hidden value="">
                  Open this select menu
                </option>
                {data[`city/${profile.province}`] &&
                  data[`city/${profile.province}`].map((city, index) => (
                    <option key={index} value={city.id}>
                      {city.name}
                    </option>
                  ))}
              </select>
            </div>

            {/* ADDRESS */}
            <div className="mb-3">
              <label htmlFor="address" className="form-label">
                Address <label className="color-red">*</label>
              </label>
              <textarea
                className="form-control"
                rows="5"
                required
                id="address"
                name="address"
                value={profile.address}
                onChange={onChange}
              />
            </div>

            {/* PHONE */}
            <div className="mb-3">
              <label htmlFor="phone" className="form-label">
                Phone Number <label className="color-red">*</label>
              </label>
              <PhoneInput
                placeholder="Please type here..."
                id="phone"
                name="phone"
                value={profile.phone}
                onChange={(phone) => setProfile({ ...profile, phone })}
                country={"id"}
                masks={{ id: "...-....-....-...." }}
              />
            </div>

            {/* SUBMIT */}
            <div className="d-grid">
              {isLoading ? (
                <LoadingButton />
              ) : (
                <Button
                  type="button"
                  className="btn btn-primary"
                  value="Update Profile"
                >
                  Update Profile
                </Button>
              )}
            </div>
          </form>

          {/* CHANGE PASS */}
          <div className="d-grid my-4">
            <p className="mb-1">
              If you want to change your password, please click
            </p>
            <button
              type="button"
              className="btn btn-dark"
              data-bs-toggle="modal"
              data-bs-target="#modalPassword"
            >
              Change password
            </button>

            <ModalChangePass />
          </div>
        </div>
      </div>
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.data,
  };
};

export default connect(mapStateToProps, { fetchData })(ProfileForm);
